var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _circle2, _circle3, _circle4, _circle5, _path20, _path21;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyCartIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 309,
    height: 216,
    viewBox: "0 0 309 216",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 138,
    cy: 108,
    r: 108,
    fill: "#B9B9B9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M304.766 115V120.498",
    stroke: "#383434",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M302 117.625H307.516",
    stroke: "#383434",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7656 26V31.4983",
    stroke: "#383434",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53 28.625H58.5156",
    stroke: "#383434",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M161.766 28V33.4983",
    stroke: "#383434",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M159 30.625H164.516",
    stroke: "#383434",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.41895 102.559L5.10889 106.949",
    stroke: "#383434",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.63086 102.992L9.03501 106.313",
    stroke: "#383434",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M259.766 54V59.4983",
    stroke: "#383434",
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M257 56.625H262.516",
    stroke: "#383434",
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M167.766 97V102.498",
    stroke: "#383434",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M165 99.625H170.516",
    stroke: "#383434",
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3.76562 9V14.4983",
    stroke: "#383434",
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1 11.625H6.51562",
    stroke: "#383434",
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M226.339 69.4961V145.765L123.697 178.553L97.3234 181.85L95.185 182.117L55.9814 100.146L60.2582 99.3767L89.4827 94.1187L226.339 69.4961Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M123.697 178.553L226.339 145.765V69.4961L89.4827 94.1187M123.697 178.553L97.3234 181.85M123.697 178.553L132.442 198.543C133.169 200.205 134.924 201.17 136.717 200.893L221.349 187.82M123.697 178.553L89.4827 94.1187M97.3234 181.85L95.185 182.117L55.9814 100.146L60.2582 99.3767M97.3234 181.85L105.559 199.075C106.754 201.576 105.106 204.505 102.348 204.781L100.887 204.927M48.8535 78.7624L60.2582 99.3767M60.2582 99.3767L89.4827 94.1187M78.7908 73.0601L89.4827 94.1187M110 204.214L127.5 202.5",
    stroke: "#383434"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1847 73.118L26.7579 86.8638L26.4254 78.3167L79.88 65.2832L80.1847 73.118Z",
    fill: "#BABFFC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M126.548 105.137L142.229 152.181",
    stroke: "#383434"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M152.209 99.4336L164 145",
    stroke: "#383434"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M174 95L181.5 140.5",
    stroke: "#383434"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M194.264 90.8789L198.5 136",
    stroke: "#383434"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.6,
    cy: 204.924,
    r: 9.97909,
    fill: "#FC9C9C"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 134.389,
    cy: 202.073,
    r: 9.97909,
    fill: "#FC9C9C"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 196.979,
    cy: 191.979,
    r: 9.97909,
    fill: "#FC9C9C"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 227.052,
    cy: 186.393,
    r: 9.97909,
    fill: "#FC9C9C"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M35 215H80",
    stroke: "#383434",
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M101 215H286",
    stroke: "#383434",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCartIcon);
export default __webpack_public_path__ + "static/media/emptyCartIcon.b77dbab1c6e8c9c15ba841735fb63ef0.svg";
export { ForwardRef as ReactComponent };